<template>
  <div class="common-layout">
    <el-container>
      <el-header v-if="showNavbar" class="header">
        <Headerbar />
      </el-header>
      <el-container class="aside-wrapper">
        <el-aside v-if="showNavbar" class="aside">
          <Navbar />
        </el-aside>
        <el-main>
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<style scope>
.common-layout {
  height: 100vh;
}

.header {
  width: 100%;
  height: 60px;
  display: flex;
  padding-left: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--el-menu-border-color);
}

.aside-wrapper {
  height: calc(100vh - 60px);
}

.aside {
  width: fit-content;
  height: 100%;
}

.el-main {
  padding: 0px;
}
</style>

<script lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Headerbar from './Headerbar.vue'
import Navbar from './Navbar.vue'

export default {
  name: 'AuthenticLayout',

  components: {
    Headerbar,
    Navbar
  },

  setup() {
    const route = useRoute()
    const showNavbar = computed(() => route.meta.requiresAuth)

    return {
      showNavbar
    }
  }
}
</script>
